import React from "react";
import { useSelector } from "react-redux";

import { CouponFilterPage } from "./couponFilter/CouponFilterPage";
import { CouponTablePage } from "./couponTable/CouponTablePage";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import classes from "./couponListPage.module.css";

import {
  selectCoupons,
  useGetCouponsListQuery,
} from "../../services/coupon/couponApiSlice";

export const CouponListPage = () => {
  const search = useSelector((state) => state.couponFilter.search);

  const { isSuccess, isFetching } = useGetCouponsListQuery({ search });

  const tableData = useSelector(selectCoupons);

  if (!isSuccess || isFetching) {
    return <CategoryPageSkeleton />;
  }

  return (
    <div className={classes.box}>
      <CouponFilterPage />
      <CouponTablePage data={tableData} />
    </div>
  );
};
